import React from 'react';
import { styled } from '../../../stitches.config';
import Socials from './Socials'

import { withDrawingBoard } from "../../HOCs/withDrawingBoard"

const LastElement = ({ blockData, articleStats }) => {
    const { url = "", authorInfo, picsInfo, additionalInfo } = blockData
    const srcUrl = url.replace("0,0,0,0", `${window.innerWidth},0,0,0`)
    return (<LastElWrapper css={{
        "$$src": `url("${srcUrl}")`
    }}>
        <div>
        </div>
        {authorInfo &&
            <ArticleInfo>
                <p>
                    <span className="article-info__authorInfo"></span>{authorInfo}
                    <br />
                    <span className="article-info__picsInfo"></span>{picsInfo}
                    {additionalInfo !== "" && <span><br /><br />{additionalInfo}</span>}
                </p>
                {/* Bug https://redmine.skolimow.com/issues/6507#note-19 */}
                {articleStats && <Socials stats={articleStats} />}
            </ArticleInfo>
        }
    </LastElWrapper>)
}

const LastElWrapper = styled("div", {
    marginTop: "30px",
    position: "relative",
    minHeight: "calc(38% + 60px)",
    "& > div:first-of-type": {
        background: "$$src center no-repeat",
        backgroundSize: "100%",
        paddingBottom: "38%",
        "@media (min-width: 992px)": {
            height: "553px"
        }
    }
});

const ArticleInfo = styled("div", {
    position: "absolute",
    top: "100%",
    left: "0",
    right: "0",
    margin: "0 38px",
    backgroundColor: "#fff",
    minHeight: "60px",
    p: {
        marginTop: "15px",
        color: "#2D2828",
        fontSize: "12px",
        letterSpacing: "-0.34px",
        lineHeight: "15px"
    },
    ".article-info__authorInfo": {
        "&::before": {
            content: '"Autor: "'
        }
    },
    ".article-info__picsInfo": {
        "&::before": {
            content: '"Zdjęcia: "'
        }
    },
    "@media (min-width: 992px)": {
        width: "220px",
        top: "90px",
        left: "123px",
        "p": {
            margin: "21px auto",
            maxHeight: "90px",
            width: "174px",
            color: "#272424",
            fontSize: "12px",
            letterSpacing: "-0.34px",
            lineHeight: "15px"
        }
    }
});

export default withDrawingBoard(props => props.blockData.hasCanvas)(LastElement)